"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SessionProvider = exports.sessionContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _swr = _interopRequireDefault(require("swr"));

var _reactRedux = require("react-redux");

var _actionCreators = require("../../redux/modules/auth/actionCreators");

var _config = require("./config");

var _types = require("./types");

/* eslint-disable no-eq-null */
const sessionContext = /*#__PURE__*/(0, _react.createContext)(undefined);
exports.sessionContext = sessionContext;

/**
 * The style of this provider is borrowed from next-auth as we plan to replace
 * this with next-auth once we have a single application.
 *
 * NOTE: This is a redux-compatible version of the same SessionProvider in
 * Aperture
 */
function _SessionProvider({
  refreshInterval,
  defaultSession,
  children,
  ...props
}) {
  // Ensure multple duplicate actions aren't dispatched to redux
  const [done, setDone] = (0, _react.useState)(false);
  const {
    data: session,
    isValidating,
    error
  } = (0, _swr.default)(_config.sessionEndpoint, async () => (await _axios.default.get(_config.sessionEndpoint)).data, {
    refreshInterval,
    shouldRetryOnError: false
  });
  (0, _react.useEffect)(() => {
    // maintain auth compatibility with redux auth saga
    if (!done && session != null) {
      props.onSuccess(session);
      setDone(true);
    }
  }, [session, done]);
  (0, _react.useEffect)(() => {
    // maintain auth compatibility with redux auth saga
    if (!done && error != null) {
      props.onFailure();
      setDone(true);
    }
  }, [session, error]);
  const loading = isValidating && session == null && error == null;
  const value = (0, _react.useMemo)(() => {
    return {
      data: session !== null && session !== void 0 ? session : null,
      status: loading ? _types.SessionStatus.Loading : session != null && error == null ? _types.SessionStatus.Authenticated : _types.SessionStatus.Unauthenticated
    };
  }, [loading, session, error]);
  return /*#__PURE__*/_react.default.createElement(sessionContext.Provider, {
    value: value
  }, children);
}

const SessionProvider = (0, _reactRedux.connect)(null, dispatch => ({
  onSuccess: session => dispatch((0, _actionCreators.sessionSuccess)(session)),
  onFailure: () => dispatch((0, _actionCreators.sessionFailure)())
}))(_SessionProvider);
exports.SessionProvider = SessionProvider;